import get_param from '../param'


export function isApp() {
  return /imgo/i.test(window.navigator.userAgent);
}

export function isWeiXin() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}


export function isZfb() {
  return /AlipayClient/i.test(window.navigator.userAgent);
}

export function isAndroid() {
  return /android/i.test(window.navigator.userAgent);
}

export function isIphone() {
  return /iphone/i.test(window.navigator.userAgent);
}


export function isIpad() {
  return /ipad/i.test(window.navigator.userAgent);
}

export function isOTT() {
  return get_param('platform') === "1"
}

//UC浏览器
export function isUCBrowser() {
  return /UCBrowser/i.test(window.navigator.userAgent)
}

export function isSupportsWebP() {
  'use strict';
  const canvas = typeof document === 'object' ? document.createElement('canvas') : {};
  canvas.width = canvas.height = 1;
  return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
};


export function os() {
  return ''

}


export function getInvoker() {
  const _invoker = get_param('fe_invoker');
  if (_invoker) {
    return _invoker;
  }
  if (isApp()) {
    if (isIpad()) {
      return 'pad-ios'
    } else if (isIphone()) {
      return 'mobile-ios'
    } else {
      return 'mobile-android'
    }
  }else if (get_param('platform') === '1') {
    return 'ott'; //只在浏览器中使用ott渠道，app中不使用,为了防止在iphone/aphone中取到ott端的产品包导致支付问题
  } else if (isWeiXin()) {
    return 'mobile-weixin'
  } else {
    return 'mobile-zhifubao' //浏览器
  }
}




export function orderInvoker() {
  if (isApp()) {
    if (isIpad()) {
      return 'pad-ios'
    } else if (isIphone()) {
      return 'mobile-ios'
    } else {
      return 'mobile-android'
    }
  } else if (isWeiXin()) {
    return 'mobile-weixin'
  } else {
    return 'mobile-zhifubao' //浏览器
  }
}



export function getPlatform() {
  if (isApp()) {
    if (isIphone()) {
      return 'iphone'
    } else if (isIpad()) {
      return 'ipad'
    } else {
      return 'android'
    }
  } else {
    if (isOTT()) {
      return 'ott';
    } else {
      return 'h5';
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/env.js